export const addressBookButtonDesc = "Y_d";
export const archiveButtonDesc = "Z_d";
export const assignPolicyButtonDesc = "__d";
export const attachFileButtonDesc = "$_d";
export const attachSignatureButtonDesc = "a$d";
export const blockButtonDesc = "b$d";
export const categorizeButtonDesc = "c$d";
export const checkNamesButtonDesc = "d$d";
export const createRuleButtonDesc = "e$d";
export const customizeButtonDesc = "f$d";
export const browseGroupsButtonDesc = "g$d";
export const deleteButtonDesc = "h$d";
export const discardButtonDesc = "i$d";
export const emojiButtonDesc = "j$d";
export const encryptButtonDesc = "k$d";
export const flagButtonDesc = "l$d";
export const flagClearFlagButtonDesc = "m$d";
export const flagNextWeekButtonDesc = "n$d";
export const flagNoDateButtonDesc = "o$d";
export const flagThisWeekButtonDesc = "p$d";
export const flagTodayButtonDesc = "q$d";
export const flagTomorrowButtonDesc = "r$d";
export const flagMarkCompleteButtonDesc = "s$d";
export const forwardButtonDesc = "t$d";
export const forwardEmailAsAttachmentDesc = "u$d";
export const getAddinsButtonDesc = "v$d";
export const highImportanceButtonDesc = "w$d";
export const ignoreButtonDesc = "x$d";
export const immersiveReaderButtonDesc = "y$d";
export const junkButtonDesc = "z$d";
export const junkFlyoutButtonDesc = "A$d";
export const lowImportanceButtonDesc = "B$d";
export const manageRulesButtonDesc = "C$d";
export const moreRetentionPoliciesButtonDesc = "D$d";
export const moveButtonDesc = "E$d";
export const newMessageButtonDesc = "F$d";
export const normalImportanceButtonDesc = "G$d";
export const phishingButtonDesc = "H$d";
export const pinButtonDesc = "I$d";
export const picturesButtonDesc = "J$d";
export const pollButtonDesc = "K$d";
export const readAloudButtonDesc = "L$d";
export const readUnreadButtonDesc = "M$d";
export const replyButtonDesc = "N$d";
export const replyAllButtonDesc = "O$d";
export const replyWithMeetingButtonDesc = "P$d";
export const rulesButtonDesc = "Q$d";
export const sendDraftButtonDesc = "R$d";
export const sensitivityButtonDesc = "S$d";
export const sensitivityLearnMoreButtonDesc = "T$d";
export const showLinkDialogButtonDesc = "U$d";
export const snoozeButtonDesc = "V$d";
export const sweepButtonDesc = "W$d";
export const tableButtonDesc = "X$d";
export const undoButtonDesc = "Y$d";
export const deleteNoteDesc = "Z$d";
export const changeNoteColorDesc = "_$d";
export const viewEmailFromNotesDesc = "$$d";
export const playMyEmailsDesc = "aae";
export const layoutDesc = "bae";
export const messagesDesc = "cae";
export default {addressBookButtonDesc,archiveButtonDesc,assignPolicyButtonDesc,attachFileButtonDesc,attachSignatureButtonDesc,blockButtonDesc,categorizeButtonDesc,checkNamesButtonDesc,createRuleButtonDesc,customizeButtonDesc,browseGroupsButtonDesc,deleteButtonDesc,discardButtonDesc,emojiButtonDesc,encryptButtonDesc,flagButtonDesc,flagClearFlagButtonDesc,flagNextWeekButtonDesc,flagNoDateButtonDesc,flagThisWeekButtonDesc,flagTodayButtonDesc,flagTomorrowButtonDesc,flagMarkCompleteButtonDesc,forwardButtonDesc,forwardEmailAsAttachmentDesc,getAddinsButtonDesc,highImportanceButtonDesc,ignoreButtonDesc,immersiveReaderButtonDesc,junkButtonDesc,junkFlyoutButtonDesc,lowImportanceButtonDesc,manageRulesButtonDesc,moreRetentionPoliciesButtonDesc,moveButtonDesc,newMessageButtonDesc,normalImportanceButtonDesc,phishingButtonDesc,pinButtonDesc,picturesButtonDesc,pollButtonDesc,readAloudButtonDesc,readUnreadButtonDesc,replyButtonDesc,replyAllButtonDesc,replyWithMeetingButtonDesc,rulesButtonDesc,sendDraftButtonDesc,sensitivityButtonDesc,sensitivityLearnMoreButtonDesc,showLinkDialogButtonDesc,snoozeButtonDesc,sweepButtonDesc,tableButtonDesc,undoButtonDesc,deleteNoteDesc,changeNoteColorDesc,viewEmailFromNotesDesc,playMyEmailsDesc,layoutDesc,messagesDesc};